import cx from 'classnames';
import {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {CSSTransition} from 'react-transition-group';
import {
  DEFAULT_INSTRUCTION_TEXT,
  DYO_INSTRUCTION_TEXT,
  INACTIVE_OBJECT_TEXT,
} from '~/common/fabric/constants';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';
import {selectIsPristineUyoByFindingId} from '~/common/fabric/reducers/fabricDesign/selectors';
import {Typography} from '~library/atoms/Typography';

export const Instructions = ({hide}) => {
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const activeObject = window.canvas?.getActiveObject();
  const isFullDyo = useSelector(
    ({fabricTemplate}) =>
      fabricTemplate.templateName.includes('general-full') &&
      fabricTemplate.templateName.includes('dyo')
  );
  const isPristineUyoByFindingId = useSelector(selectIsPristineUyoByFindingId);

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    if (activeObject) {
      dispatch({type: UPDATE_DESIGN_OPTIONS, payload: {touched: true}});
    }

    return () => {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {textAreaOpen: false},
      });
    };
  }, [activeObject]);

  let instructionText = DEFAULT_INSTRUCTION_TEXT;

  if (isPristineUyoByFindingId) {
    instructionText = DEFAULT_INSTRUCTION_TEXT;
  } else if (activeObject === null) {
    // NOTE: when 'activeObject' is null, it means that the user has previously select on an object
    instructionText = INACTIVE_OBJECT_TEXT;
  } else if (isFullDyo) {
    instructionText = DYO_INSTRUCTION_TEXT;
  }
  return (
    <CSSTransition
      nodeRef={containerRef}
      in={hide}
      timeout={{appear: 500}}
      classNames="hide-for-mset-preview"
    >
      <div
        className={cx({'welcome-instructions-container': true, 'init-hidden': hide})}
        ref={containerRef}
      >
        <div className="edit_box welcome-instructions">
          <img
            className="welcome-instructions-img"
            src="/assets/images/step-1-instructions-img.png"
            alt=""
          />
          <Typography as="p" variant="paragraph2" size="medium" color="pebble">
            {instructionText}
          </Typography>
        </div>
      </div>
    </CSSTransition>
  );
};
